import { format, formatDistanceToNow } from "date-fns";

type DateFnsFormatProps = {
	date: Date | number;
	className?: string;
} & (
	| { formatStr: string; relative?: false }
	| { formatStr?: never; relative: true; addSuffix?: boolean }
);

export function DateFnsFormat({
	date,
	className,
	...props
}: DateFnsFormatProps) {
	const dateObj = date instanceof Date ? date : new Date(date);

	const formattedDate =
		"relative" in props && props.relative
			? formatDistanceToNow(dateObj, { addSuffix: props.addSuffix ?? true })
			: format(dateObj, props.formatStr);

	return (
		<time dateTime={dateObj.toISOString()} className={className}>
			{formattedDate}
		</time>
	);
}
